"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNetworkOwner = exports.isLocationOwner = exports.CalendarAction = void 0;
var CalendarAction;
(function (CalendarAction) {
    CalendarAction["PICKUP_CALENDAR_UPDATE"] = "pickup_calendar_update";
    CalendarAction["WORKING_DAY_CALENDAR_UPDATE"] = "working_days_calendar_update";
})(CalendarAction = exports.CalendarAction || (exports.CalendarAction = {}));
function isLocationOwner(owner) {
    var _a;
    return ((_a = owner) === null || _a === void 0 ? void 0 : _a.logisticsLocationId) !== undefined;
}
exports.isLocationOwner = isLocationOwner;
function isNetworkOwner(owner) {
    var _a;
    return ((_a = owner) === null || _a === void 0 ? void 0 : _a.logisticsNetworkId) !== undefined;
}
exports.isNetworkOwner = isNetworkOwner;
//# sourceMappingURL=calendar-models.v0.js.map